<template>
    <j-modal :title="title" :width="width" :visible="visible" switchFullscreen @ok="handleOk" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }" @cancel="handleCancel" cancelText="关闭">
        <def-standard-form ref="realForm" @ok="submitCallback" :devClassList="devClassList" :disabled="disableSubmit"></def-standard-form>
    </j-modal>
</template>

<script>
    import DefStandardForm from './DefStandardForm'
    export default {
        name: 'DefStandardModal',
        components: {
            DefStandardForm
        },
        props: {
            devClassList: {
                type: Array
            }
        },
        data() {
            return {
                title: '',
                width: 800,
                visible: false,
                disableSubmit: false
            }
        },
        methods: {
            add() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.realForm.add();
                })
            },
            edit(record) {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.realForm.edit(record);
                })
            },
            close() {
                this.$emit('close');
                this.visible = false;
            },
            handleOk() {
                this.$refs.realForm.submitForm();
            },
            submitCallback() {
                this.$emit('ok');
                this.visible = false;
            },
            handleCancel() {
                this.close()
            }
        }
    }
</script>